<div
  class="slider"
  [class]="{
    'slider--disabled': disabled,
    'slider--hide-active-value': hideActiveValue()
  }"
>
  <div class="slider__input-container">
    <input
      class="slider__input"
      type="range"
      [disabled]="disabled"
      [(ngModel)]="valueShownInUi"
      [max]="max()"
      [min]="min()"
      [step]="step()"
      [id]="id()"
    />
    <div #sliderCurrentValue class="slider__current-value">
      @if (valueFormatter()) {
        {{ formatValue(positiveValue) }}
      } @else {
        {{ positiveValue | number }} {{ unit() }}
      }
    </div>
    <div
      #sliderFallbackProgress
      class="slider__fallback-progress"
      [class.slider__fallback-progress--disabled]="disabled"
    ></div>
  </div>
  <div class="slider__label-container">
    <div
      class="slider__label-min"
      [class.slider__label-min--equals-current]="currentValueEqualsMin"
    >
      @if (valueFormatter()) {
        {{ formatValue(min()) }}
      } @else {
        {{ min() | number }} {{ unitMin() || unit() }}
      }
    </div>
    <div
      class="slider__label-max"
      [class.slider__label-max--equals-current]="currentValueEqualsMax"
    >
      @if (valueFormatter()) {
        {{ formatValue(max()) }}
      } @else {
        {{ max() | number }} {{ unitMax() || unit() }}
      }
    </div>
  </div>
</div>
